<template>
    <v-container fluid>
        <v-row class="ma-4">
            <v-dialog v-model="group" persistent width="80vw">
                <template v-slot:activator="{ on, attrs }">
                    <v-btn color="warning" dark v-bind="attrs" v-on="on">Создать подгруппу</v-btn>
                </template>
                <v-card>

                    <v-card-title>
                        <span class="headline">Создание Подгруппы</span>
                    </v-card-title>

                    <v-card-text>
                        <v-container>
                            <v-row>
                                <v-col cols="6" sm="6" md="6">
                                    <v-text-field label="Название подгруппы*" required v-model="sub_group_name"></v-text-field>
                                </v-col>
                                <v-col cols="6" sm="6" md="6">
                                    <v-select
                                        v-model="sub_group_type"
                                        :items="sub_groups"
                                        item-text="name"
                                        item-value="type"
                                        label="Выберите тип подгруппы"
                                        persistent-hint
                                        return-object
                                        single-line
                                    ></v-select>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-text>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" text @click="group = false">Закрыть</v-btn>
                        <v-btn color="warning" dark @click="save_group()">Сохранить</v-btn>
                    </v-card-actions>

                </v-card>
            </v-dialog>
        </v-row>
        <div class="groups-grid">
            <SubGroup v-for="group in get_sub_groups" :key="group._id" :group="group" :edited="true" :with_name="true" small/>
        </div>
    </v-container>
</template>

<script>

import SubGroup from '@/components/sub_groups/SubGroup.vue'
import { mapGetters, mapActions } from 'vuex'

export default {
    name: 'SubGroupView',
    data: () => ({
      group: false,
      sub_group_name: null,
      sub_group_type: null,
      sub_groups: [
            {
                type: 'product',
                name: 'Продукт'
            },
            {
                type: 'accessory',
                name: 'Комплектующая'
            },
      ]
     
    }),
    components:{
        SubGroup
    },
    created () {
        this.load_sub_groups({type :'all' })
    },
    computed: {
        ...mapGetters([
             'get_sub_groups', 'get_baseURL'
        ]),
    },
    methods: {
        ...mapActions([
            'load_sub_groups', 'load_accessories', 'create_product', 'add_image', 'create_sub_group'
        ]),
        
        save_group(){
            if(!this.sub_group_name || !this.sub_group_type) return false
            this.create_sub_group({name : this.sub_group_name, type: this.sub_group_type.type })
            .then(() => {
                this.sub_group_name = null
                this.group = false
            }).catch(err => {
                console.log(err);
            })
        },
    },
}
</script>

<style>
.groups-grid{
    display: grid;
    grid-template-columns: repeat(auto-fit, 1fr);
    grid-gap: 1rem;
    width: 100%;
}

.products-grid{
    flex-wrap: wrap;
    display: flex;
    gap: 15px;
}

.blocks-list{
    display: grid;
    grid-template-columns: repeat(auto-fit, 192px);
    grid-gap: 1rem;
    margin: 20px
}
</style>